$(".vid_1_n").on("click", function(e) {
    e.preventDefault(); 
 
    window.open("https://www.instagram.com/cristelusa", "_blank"); // Open in a new tab
});
$(".vid_2_n").on("click", function(e) {
    e.preventDefault(); 
 
    window.open("https://www.instagram.com/cristelusa", "_blank"); // Open in a new tab
});
$(".vid_3_n").on("click", function(e) {
    e.preventDefault(); 
 
    window.open("https://www.instagram.com/cristelusa", "_blank"); // Open in a new tab
});
$(".vid_4_n").on("click", function(e) {
    e.preventDefault(); 
 
    window.open("https://www.instagram.com/cristelusa", "_blank"); // Open in a new tab
});